var MeasurementsPrice = 0;
var HeaderType = 0;
var Position = 1;
var Lining = 0;
var LiningPrice = 0;
var ManufactureMakeUp = 2600;
var ManufactureFabricLining = 0;
var metresWidth = 0;
var metres = 0;
var eachCurtain = 0;
var LiningLineItem = "Unlined";
var headFullness = 0;
var CurtainMetres = 0;
var totalPoles = 0;
var addOnId;

var headerQuantity = 0;
var liningQuantity = 0;
var headerId, metres, customWidth, customDrop, headSize, CutSize, CurtainTotal;
var liningId = null;

var maxSize = 400;
var minSize = 70;

var classnameCurtainSize = document.getElementsByClassName("curtain-size");
var classnameHeaderType = document.getElementsByClassName("header-type");
var classnameHeaderTypeOptions = document.getElementsByClassName("header-type-options");
var classnamePosition = document.getElementsByClassName("position");
var classnameLining = document.getElementsByClassName("lining");
var classnameNeedHelp = document.getElementsByClassName("need-help");
var addOns = document.getElementsByClassName('add-on-option');
var locationSelect = document.getElementById('locationSelect');

for (var i = 0; i < classnameCurtainSize.length; i++) {
    classnameCurtainSize[i].addEventListener('input', CurtainSize, false);
}
for (var i = 0; i < classnameHeaderType.length; i++) {
    classnameHeaderType[i].addEventListener('click', CurtainHeaderType, false);
}
for (var i = 0; i < classnameHeaderTypeOptions.length; i++) {
    classnameHeaderTypeOptions[i].addEventListener('click', HeaderTypeOptions, false);
}
for (var i = 0; i < classnamePosition.length; i++) {
    classnamePosition[i].addEventListener('click', CurtainPosition, false);
}
for (var i = 0; i < classnameLining.length; i++) {
    classnameLining[i].addEventListener('click', CurtainLining, false);
}

for (var i = 0; i < classnameNeedHelp.length; i++) {
    classnameNeedHelp[i].addEventListener('click', NeedHelp, false);
}

// Accordion
// document.addEventListener('click', function (event) {
//     //Bail if our clicked element doesn't have the class
//     if (!event.target.classList.contains('accordion-toggle')) return;
//     // Get the target content
//     var content = document.querySelector(event.target.dataset.hash);
//     var accordionsTitle = content.previousElementSibling;
//     if (!content) return;
//     // Prevent default link behavior
//     // If the content is already expanded, collapse it and quit
//     if (content.classList.contains('active')) {
//         content.classList.remove('active');
//         accordionsTitle.classList.remove('active');
//         return;
//     }
//     // scroll to the top of open accordion
//     if (window.innerWidth < 768) {
//         if (event.target.dataset.hash == "#content-1") {
//             document.getElementById('content-1').scrollIntoView({
//                 behavior: "smooth"
//             });
//         } else {
//             accordionsTitle.previousElementSibling.previousElementSibling.scrollIntoView({
//                 behavior: "smooth"
//             });
//         }
//     }
//     // Get all open accordion content, loop through it, and close it
//     var accordions = document.querySelectorAll('.accordion-content.active');
//     var accordionsTitles = document.querySelectorAll('.accordion-toggle');
//     for (var i = 0; i < accordions.length; i++) {
//         accordions[i].classList.remove('active');
//     }
//     for (var x = 0; x < accordionsTitles.length; x++) {
//         accordionsTitles[x].classList.remove('active');
//     }
//     // Toggle our content
//     content.classList.toggle('active');

//     if (content.classList.contains('active')) {
//         accordionsTitle.classList.add('active');
//     } else {
//         accordionsTitle.classList.remove('active');
//     }
// })

var inputContainer = document.querySelector('.measurement-input-container');
var lengthContainer = document.querySelector('.measurement-input-lengths');
var reverseContainer = document.querySelector('.measurement-input-reverse-lengths');
var crossLengths = document.querySelector('.measurement-input-cross-lengths');
var inputDegress = document.querySelector('.measurement-input-degrees');
var handContainer = document.querySelector('.measurement-hand');
var imageContainer = document.querySelector('.measurement-image-container')
var options = document.getElementsByClassName('option-holder');
var handRadios = document.getElementsByClassName('hand-radio');
var diagrams = document.getElementsByClassName('measurement-image-container--image');
var measurementInputs = document.getElementsByClassName('measurement-input');
var totalElement = document.getElementById('totalLength');
var empty = true;
var total = 0;
var brackets = 2;
var cornerJoints = 0;
var bendQuantity = 0;
var semiBendQuantity = 0;
document.getElementById('baySelect').addEventListener('change', function(e){
    resetAll();
    imageContainer.classList.add('active');
    inputContainer.classList.add('active');
    if(this.options[this.selectedIndex].dataset.option == 'straight') {
        lengthContainer.classList.add('active');
        document.getElementById('length').parentElement.classList.add('active');
    }
    if(this.options[this.selectedIndex].dataset.option == 'single-bend-bay') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        handContainer.classList.add('active');
        for(const radio of handRadios) {
            radio.parentElement.classList.add('active');
        }
        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('cross_ac').parentElement.classList.add('active');
        document.getElementById('angle_b').parentElement.classList.add('active');

        document.getElementById('singleBendImage').classList.add('active');
        document.getElementById('singleBendImageTwo').classList.add('active');

        brackets = 4;
        cornerJoints = 1;
        bendQuantity = 1; 
    }
    if(this.options[this.selectedIndex].dataset.option == 'single-bend-bay-with-reverse-end') {
        lengthContainer.classList.add('active');
        reverseContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        handContainer.classList.add('active');
        for(const radio of handRadios) {
            radio.parentElement.classList.add('active');
        }
        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('reverse-1a').parentElement.classList.add('active');
        document.getElementById('cross_ac').parentElement.classList.add('active');
        document.getElementById('angle_a').parentElement.classList.add('active');
        document.getElementById('angle_b').parentElement.classList.add('active');

        document.getElementById('singleBendRevImage').classList.add('active');
        document.getElementById('singleBendRevImageTwo').classList.add('active');

        brackets = 4;
        cornerJoints = 1;
        bendQuantity = 1;
    }
    if(this.options[this.selectedIndex].dataset.option == 'two-bend-bay') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');

        document.getElementById('cross_ac').parentElement.classList.add('active');
        document.getElementById('cross_ad').parentElement.classList.add('active');
        document.getElementById('cross_bd').parentElement.classList.add('active');

        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');

        document.getElementById('twoBendBay').classList.add('active');
        document.getElementById('twoBendBayTwo').classList.add('active');

        brackets = 6;
        cornerJoints = 2;
        bendQuantity = 2;
    }
    if(this.options[this.selectedIndex].dataset.option == 'two-bend-bay-with-reverse-ends') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        reverseContainer.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');

        document.getElementById('reverse-1a').parentElement.classList.add('active');
        document.getElementById('reverse-2d').parentElement.classList.add('active');

        document.getElementById('cross_ac').parentElement.classList.add('active');
        document.getElementById('cross_ad').parentElement.classList.add('active');
        document.getElementById('cross_bd').parentElement.classList.add('active');

        document.getElementById('angle_a').parentElement.classList.add('active');
        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');

        document.getElementById('twoBendRevBay').classList.add('active');
        document.getElementById('twoBendBayRevTwo').classList.add('active');

        brackets = 6;
        cornerJoints = 2;
        bendQuantity = 4;
    }
    if(this.options[this.selectedIndex].dataset.option == 'four-bend-bay') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');
        document.getElementById('length-de').parentElement.classList.add('active');
        document.getElementById('length-ef').parentElement.classList.add('active');

        document.getElementById('cross_ad').parentElement.classList.add('active');
        document.getElementById('cross_ae').parentElement.classList.add('active');
        document.getElementById('cross_af').parentElement.classList.add('active');
        document.getElementById('cross_fb').parentElement.classList.add('active');
        document.getElementById('cross_fc').parentElement.classList.add('active');

        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');
        document.getElementById('angle_e').parentElement.classList.add('active');

        document.getElementById('fourBendBay').classList.add('active');
        document.getElementById('fourBendBayTwo').classList.add('active');

        brackets = 10;
        cornerJoints = 4;
        bendQuantity = 4;
    }
    if(this.options[this.selectedIndex].dataset.option == 'four-bend-bay-with-reverse-ends') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        reverseContainer.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');
        document.getElementById('length-de').parentElement.classList.add('active');
        document.getElementById('length-ef').parentElement.classList.add('active');

        document.getElementById('reverse-1a').parentElement.classList.add('active');
        document.getElementById('reverse-2f').parentElement.classList.add('active');

        document.getElementById('cross_ad').parentElement.classList.add('active');
        document.getElementById('cross_ae').parentElement.classList.add('active');
        document.getElementById('cross_af').parentElement.classList.add('active');
        document.getElementById('cross_fb').parentElement.classList.add('active');
        document.getElementById('cross_fc').parentElement.classList.add('active');

        document.getElementById('angle_a').parentElement.classList.add('active');
        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');
        document.getElementById('angle_e').parentElement.classList.add('active');
        document.getElementById('angle_f').parentElement.classList.add('active');

        document.getElementById('fourBendRevBay').classList.add('active');
        document.getElementById('fourBendRevBayTwo').classList.add('active');

        brackets = 10;
        cornerJoints = 4;
        bendQuantity = 6;
    }
    if(this.options[this.selectedIndex].dataset.option == 'five-bend-bay') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');
        document.getElementById('length-de').parentElement.classList.add('active');
        document.getElementById('length-ef').parentElement.classList.add('active');
        document.getElementById('length-fg').parentElement.classList.add('active');

        document.getElementById('cross_ad').parentElement.classList.add('active');
        document.getElementById('cross_ae').parentElement.classList.add('active');
        document.getElementById('cross_af').parentElement.classList.add('active');
        document.getElementById('cross_ag').parentElement.classList.add('active');
        document.getElementById('cross_gb').parentElement.classList.add('active');
        document.getElementById('cross_gc').parentElement.classList.add('active');
        document.getElementById('cross_gd').parentElement.classList.add('active');

        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');
        document.getElementById('angle_e').parentElement.classList.add('active');
        document.getElementById('angle_f').parentElement.classList.add('active');

        document.getElementById('fiveBendBay').classList.add('active');

        brackets = 12;
        cornerJoints = 5;
        bendQuantity = 5;
    }
    if(this.options[this.selectedIndex].dataset.option == 'five-bend-bay-with-reverse-ends') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        reverseContainer.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');
        document.getElementById('length-de').parentElement.classList.add('active');
        document.getElementById('length-ef').parentElement.classList.add('active');
        document.getElementById('length-fg').parentElement.classList.add('active');

        document.getElementById('reverse-1a').parentElement.classList.add('active');
        document.getElementById('reverse-2g').parentElement.classList.add('active');

        document.getElementById('cross_ad').parentElement.classList.add('active');
        document.getElementById('cross_ae').parentElement.classList.add('active');
        document.getElementById('cross_af').parentElement.classList.add('active');
        document.getElementById('cross_ag').parentElement.classList.add('active');
        document.getElementById('cross_gb').parentElement.classList.add('active');
        document.getElementById('cross_gc').parentElement.classList.add('active');
        document.getElementById('cross_gd').parentElement.classList.add('active');

        document.getElementById('angle_a').parentElement.classList.add('active');
        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');
        document.getElementById('angle_e').parentElement.classList.add('active');
        document.getElementById('angle_f').parentElement.classList.add('active');
        document.getElementById('angle_g').parentElement.classList.add('active');

        document.getElementById('fiveBendRevBay').classList.add('active');

        brackets = 12;
        cornerJoints = 5;
        bendQuantity = 7;
    }
    if(this.options[this.selectedIndex].dataset.option == 'six-bend-bay') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');
        document.getElementById('length-de').parentElement.classList.add('active');
        document.getElementById('length-ef').parentElement.classList.add('active');
        document.getElementById('length-fg').parentElement.classList.add('active');
        document.getElementById('length-gh').parentElement.classList.add('active');

        document.getElementById('cross_ae').parentElement.classList.add('active');
        document.getElementById('cross_af').parentElement.classList.add('active');
        document.getElementById('cross_ag').parentElement.classList.add('active');
        document.getElementById('cross_ah').parentElement.classList.add('active');
        document.getElementById('cross_hb').parentElement.classList.add('active');
        document.getElementById('cross_hc').parentElement.classList.add('active');
        document.getElementById('cross_hd').parentElement.classList.add('active');

        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');
        document.getElementById('angle_e').parentElement.classList.add('active');
        document.getElementById('angle_f').parentElement.classList.add('active');
        document.getElementById('angle_g').parentElement.classList.add('active');

        document.getElementById('sixBendBay').classList.add('active');

        brackets = 14;
        cornerJoints = 6;
        bendQuantity = 6;
    }
    if(this.options[this.selectedIndex].dataset.option == 'six-bend-bay-with-reverse-ends') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        reverseContainer.classList.add('active');

        document.getElementById('length-ab').parentElement.classList.add('active');
        document.getElementById('length-bc').parentElement.classList.add('active');
        document.getElementById('length-cd').parentElement.classList.add('active');
        document.getElementById('length-de').parentElement.classList.add('active');
        document.getElementById('length-ef').parentElement.classList.add('active');
        document.getElementById('length-fg').parentElement.classList.add('active');
        document.getElementById('length-gh').parentElement.classList.add('active');

        document.getElementById('reverse-1a').parentElement.classList.add('active');
        document.getElementById('reverse-2h').parentElement.classList.add('active');

        document.getElementById('cross_ae').parentElement.classList.add('active');
        document.getElementById('cross_af').parentElement.classList.add('active');
        document.getElementById('cross_ag').parentElement.classList.add('active');
        document.getElementById('cross_ah').parentElement.classList.add('active');
        document.getElementById('cross_hb').parentElement.classList.add('active');
        document.getElementById('cross_hc').parentElement.classList.add('active');
        document.getElementById('cross_hd').parentElement.classList.add('active');

        document.getElementById('angle_a').parentElement.classList.add('active');
        document.getElementById('angle_b').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');
        document.getElementById('angle_d').parentElement.classList.add('active');
        document.getElementById('angle_e').parentElement.classList.add('active');
        document.getElementById('angle_f').parentElement.classList.add('active');
        document.getElementById('angle_g').parentElement.classList.add('active');
        document.getElementById('angle_h').parentElement.classList.add('active');

        document.getElementById('sixBendRevBay').classList.add('active');

        brackets = 14;
        cornerJoints = 6;
        bendQuantity = 8;
    }
    if(this.options[this.selectedIndex].dataset.option == 'semi-circular-bay') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');

        document.getElementById('length-ac').parentElement.classList.add('active');
        document.getElementById('length-bd').parentElement.classList.add('active');

        document.getElementById('cross_wx').parentElement.classList.add('active');
        document.getElementById('cross_yz').parentElement.classList.add('active');
        document.getElementById('cross_ax').parentElement.classList.add('active');
        document.getElementById('cross_cz').parentElement.classList.add('active');

        document.getElementById('semiBay').classList.add('active');
        
        semiBendQuantity = 1;
    }
    if(this.options[this.selectedIndex].dataset.option == 'semi-circular-bay-with-reverse-ends') {
        lengthContainer.classList.add('active');
        crossLengths.classList.add('active');
        inputDegress.classList.add('active');
        reverseContainer.classList.add('active');

        document.getElementById('length-ac').parentElement.classList.add('active');
        document.getElementById('length-bd').parentElement.classList.add('active');

        document.getElementById('reverse-1a').parentElement.classList.add('active');
        document.getElementById('reverse-2c').parentElement.classList.add('active');

        document.getElementById('cross_wx').parentElement.classList.add('active');
        document.getElementById('cross_yz').parentElement.classList.add('active');
        document.getElementById('cross_ax').parentElement.classList.add('active');
        document.getElementById('cross_cz').parentElement.classList.add('active');

        document.getElementById('angle_a').parentElement.classList.add('active');
        document.getElementById('angle_c').parentElement.classList.add('active');

        document.getElementById('semiRevBay').classList.add('active');
        semiBendQuantity = 1;
        bendQuantity = 2;
    }

    retrieveActiveInputs();
});

function resetAll () {
    lengthContainer.classList.remove('active');
    reverseContainer.classList.remove('active');
    crossLengths.classList.remove('active');
    inputDegress.classList.remove('active');
    imageContainer.classList.remove('active');
    total = 0;
    totalElement.innerText = total;
    
    for(const input of measurementInputs) {
        input.value = '';
    }
    for(const option of options) {
        option.classList.remove('active');
    }
    for(const diagram of diagrams) {
        diagram.classList.remove('active');
    }
}

function getClosestVariant(product, total) {
    var lengthArray = [];
    var closest = 0;
    var totalInMetres = parseInt(total) / 100;
    for(const variant of product.variants) {
        //console.log(variant);
        var numberForArray = variant.title.split(' ')[0];
        numberForArray = numberForArray.replace('m', '');
        numberForArray = parseFloat(numberForArray);
        lengthArray.push(numberForArray);
    }

    var closest = lengthArray.reduce(function(prev, curr) {
        return (Math.abs(curr - totalInMetres) < Math.abs(prev - totalInMetres) ? curr : prev);
    });

    if(closest < totalInMetres) {
        const found = lengthArray.find((element) => element > totalInMetres);
        closest = found;
    }

    var closestString = closest.toString();

    for(const variant of product.variants) {
        if(variant.title.indexOf(closestString) > -1) {
            DefaultProductId = variant.id;
            costPerMetre = variant.price;
            UpdateButtonPrice();
        }
    }

}

function getProduct(total) {
    fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
    .then(response => response.json())
    .then(product => getClosestVariant(product, total));
}

function retrieveActiveInputs() {
    var actives = document.querySelectorAll('.option-holder.active .measurement-length');
    total = 0;
    totalPoles = 0;
    empty = false;
    for(const active of actives) {
        if(active.value != '') {
            total = total + parseInt(active.value);
            totalElement.innerText = total;


            if(!document.querySelector('.custom-bay-calculator')) {
                getProduct(total);
            }
        } else {
            empty = true;
        }
    }

    UpdateButtonPrice();
} 

var actives = document.querySelectorAll('.measurement-length');
for(const active of actives) {
    active.addEventListener('change', function(){
        retrieveActiveInputs();
        if(empty == false) {
            document.getElementById('addToCartPopUp').removeAttribute('disabled');
        }
    });
}


function NeedHelp() {
    //window.location.href = NeedHelpUrl;
    window.open(
        NeedHelpUrl,
        '_blank' // <- This is what makes it open in a new window.
    );
}

// clear accordion inputs on browser's 'go back'
window.addEventListener("pageshow", () => {
    var clearAllInputs = document.querySelectorAll('.made-to-measure-accordion input');
    var clearAllCheckedClasses = document.querySelectorAll('.checked');
    for (clearAllInput of clearAllInputs) {
        if(!clearAllInput.classList.contains('measurement-radio')) {
            clearAllInput.checked = false;
        }        
    }
    for (clearAllCheckedClass of clearAllCheckedClasses) {
        clearAllCheckedClass.classList.remove('checked');
    }
});

function CurtainPosition() {
    const positionTypes = document.querySelectorAll(".position");
    for (positionType of positionTypes) {
        if(positionType.checked) {
            positionType.parentNode.classList.add('checked');
        } else {
            positionType.parentNode.classList.remove('checked');
        }
    }

    UpdateButtonPrice();
}

function CurtainLining() {
    const liningTypes = document.querySelectorAll(".lining");
    for (liningType of liningTypes) {
        if (liningType.checked) {
            liningType.parentNode.classList.add('checked');

            if(liningType.value == 'Ceiling' && liningType.name == 'bracket') {
                document.querySelector('.distance-ceiling-input').classList.add('active');
            } else if (liningType.value != 'Ceiling' && liningType.name == 'bracket') {
                document.querySelector('.distance-ceiling-input').classList.remove('active');
                document.querySelector('.distance-ceiling-input input').value = '';
            }
        } else {
            liningType.parentNode.classList.remove('checked');
        }
    }

    UpdateButtonPrice()
}

function UpdateButtonPrice() {
    var currentTotal = 0;
    var bracketTotal = 0;
    var finialTotal = 0;
    var cornerTotal = 0;
    var allBends = 0;

    if(!document.querySelector('.custom-bay-calculator')) {
        totalPoles = 1;
    } else {
        totalPoles = parseInt(total) / minimumPoleLength;
    }

    currentTotal = parseInt(totalPoles) * parseInt(costPerMetre);

    var bracketItem = document.querySelector('.made-to-measure-input--bracket.checked input');
    var finialItem = document.querySelector('.made-to-measure-input--finial.checked input');
    var gliderItem = document.querySelector('.made-to-measure-input--tracklist.checked input');

    if(bracketItem) {
        var price = parseInt(bracketItem.dataset.price);
        bracketTotal = price * parseInt(brackets);
        currentTotal = currentTotal + bracketTotal;
    }

    if(!document.querySelector('.custom-bay-calculator')) {
        cornerTotal = parseInt(cornerJointPrice) * cornerJoints;
        currentTotal = currentTotal + cornerTotal;
    }

    if(document.querySelector('.custom-bay-calculator')) {
        var semiBendPrice = 13600;
        var bendPrice = 10000;
        var semiBendTotal = semiBendPrice * semiBendQuantity;
        var bendTotal = bendPrice * bendQuantity;
        allBends = bendTotal + semiBendTotal;
        currentTotal = currentTotal + allBends;
    }

    if(finialItem) {
        var price = parseInt(finialItem.dataset.price);
        finialTotal = price * 2;
        currentTotal = currentTotal + finialTotal;
    }

    if(gliderItem) {
        var price = parseInt(gliderItem.dataset.price);
        var gliderItemTotal = parseInt(total) / 100;
        gliderItemTotal = Math.ceil(gliderItemTotal)
        gliderTotal = price * gliderItemTotal;
        currentTotal = currentTotal + gliderTotal;
    }

    if(document.querySelector('.made-to-measure-input--position.checked input') && document.querySelector('.made-to-measure-input--position.checked input').value == 'Pair') {
        currentTotal = currentTotal + parseInt(pulleyPrice);
    }

    currentTotal = currentTotal / 100;

    document.getElementById('total').innerHTML = "£" + currentTotal.toFixed(2);
}

function UpdateCartQuantity() {
    var addItem = document.querySelectorAll('.js-cart-count')
    var addItemsCount = document.querySelectorAll('.product-remove');
    for (var i = 0; i < addItem.length; i++) {
        addItem[i].innerHTML = parseInt(addItemsCount.length) + 1;
    }
}

//Generate random key so if the same product is added, it displays as separate
let random_key;
function generateRandomKey() {
    function makeid(length) {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }
    random_key = makeid(6);
    //console.log(random_key)
}
generateRandomKey();

for(const addOn of addOns) {
    addOn.addEventListener('click', function(){
        addOn.classList.add('checked');
        var checkbox = addOn.querySelector('.add-on-option-checkbox-input');
        if(checkbox.checked) {
            addOnId = parseInt(checkbox.dataset.id);
            var price = parseFloat(checkbox.dataset.price);
            // if (!isNaN(parseFloat(totalVAT))) {
            //     var sum = totalVAT + price;
            //     document.getElementById('total').innerHTML = "£" + sum.toFixed(2);
            // }
        } else {
            addOnId = '';
            addOn.classList.remove('checked');
            // document.getElementById('total').innerHTML = "£" + totalVAT.toFixed(2);
        }
    });
}

document.getElementById('addToCartPopUp').addEventListener('click', (event) => {
    document.getElementById('pop-up-container').style.display = 'flex';
});

document.getElementById('AddtoCartCustomCurtain').addEventListener('click', (event) => {

    var bracketId = document.querySelector('.made-to-measure-input--bracket.checked input').dataset.id;

    var finial = document.querySelector('.made-to-measure-input--finial.checked input').dataset.id;

    var properties = {};
    var actives = document.querySelectorAll('.option-holder.active .measurement-input');
    for(const active of actives) {
        properties[active.previousElementSibling.innerText] = active.value;
    }

    if(document.querySelector('.custom-bay-calculator')) {
        properties[document.querySelector('.made-to-measure-input--position.checked input').name] = document.querySelector('.made-to-measure-input--position.checked input').value;

        properties[document.querySelector('.made-to-measure-input--cord.checked input').name] = document.querySelector('.made-to-measure-input--cord.checked input').value;

        properties[document.querySelector('.made-to-measure-input--track.checked input').name] = document.querySelector('.made-to-measure-input--track.checked input').value;

        properties[document.querySelector('.distance-option input').name] = document.querySelector('.distance-option input').value;

        properties[document.querySelector('.distance-ceiling-input input').name] = document.querySelector('.distance-ceiling-input input').value;
        
        cornerJoints = 0;

        totalPoles = parseInt(total) / minimumPoleLength;

        totalPoles = Math.ceil(totalPoles)
    } else {
        totalPoles = 1;
    }

    var addData = {
        items: [
            {
                id: parseInt(DefaultProductId),
                quantity: totalPoles,
                properties: properties
            },
            {
                id: parseInt(bracketId),
                quantity: brackets
            },
            {
                id: parseInt(finial),
                quantity: 2
            },
            {
                id: parseInt(cornerJointId),
                quantity: cornerJoints
            }
        ]
    };

    // console.log(properties);

    if(addOnId) {

        var totalRings = parseInt(total) / 100;

        if(Number.isInteger(totalRings) == false) {
            totalRings = Math.floor(totalRings) * 10;
            totalRings = totalRings + 6;
        }

        var addOn = { id: addOnId, quantity: totalRings };
        addData.items.push(addOn);
    }

    if(document.querySelector('.made-to-measure-input--position.checked input') && document.querySelector('.made-to-measure-input--position.checked input').value == 'Pair') {
        var PulleyAddOn = { id: pulley, quantity: 1 };
        addData.items.push(PulleyAddOn);
    }

    if(document.querySelector('.made-to-measure-input--tracklist.checked input') && document.querySelector('.made-to-measure-input--tracklist.checked input').value) {
        var totalGlider = parseInt(total) / 25;
        totalGlider = Math.ceil(totalGlider)
        var gliderAddOn = { id: document.querySelector('.made-to-measure-input--tracklist.checked input').dataset.id, quantity: totalGlider };
        addData.items.push(gliderAddOn);
    }

    if(document.querySelector('.custom-bay-calculator')) {
        var bendAddOn = { id: bendId, quantity: bendQuantity };
        addData.items.push(bendAddOn);
        var semiBendAddOn = { id: semiBendId, quantity: semiBendQuantity };
        addData.items.push(semiBendAddOn);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(addData)
    })
    .then(response => {
        console.log(response);
        location.href = '/cart';
    })
    .catch((error) => {
        console.error('Error:', error);
    });
});  